import { render } from "./team-members.vue?vue&type=template&id=2aecfd85"
import script from "./team-members.vue?vue&type=script&lang=js"
export * from "./team-members.vue?vue&type=script&lang=js"

import exportComponent from "/Users/drewcarrette/Sites/connected-medical/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__